import "./css/index.css";
import React from "react";
import { ODSLogoProps } from "./ODSLogo.types";
import classNames from "classnames";

const ODSLogo: React.FC<ODSLogoProps> = ({
  variant: variantProp = "primary",
  type: typeProp = "primary",
  size,
  className,
  style: styleProp = {},
  ...rest
}) => {
  const style =
    size != null ? { width: size, height: size, ...styleProp } : styleProp;
  const type = typeProp ?? variantProp;
  return (
    <a
      style={style}
      className={classNames(`ODSLogo`, `ODSLogo--type-${type}`, className)}
      {...rest}
    >
      <svg viewBox="0 0 48 49" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.5763 30.7455H8V23.1455H15.5763V30.7455ZM8 5.64551V18.5455H10.2928V18.1455C10.2928 12.0455 13.6822 8.24551 20.162 8.24551H20.5607V35.6455C20.5607 39.4455 19.0654 40.9455 15.2773 40.9455H14.081V43.6455H33.8193V40.9455H32.7227C28.9346 40.9455 27.4393 39.4455 27.4393 35.6455V8.34551H27.838C34.3178 8.34551 37.7072 12.1455 37.7072 18.2455V18.6455H40V5.64551L8 5.64551ZM32.2243 30.7455H39.8006V23.1455H32.2243V30.7455Z" />
      </svg>
    </a>
  );
};

export default ODSLogo;
